import gql from 'graphql-tag';

export const GET_DEAL_BUILDERS = gql`
  query GetDealBuilders($vendorOpportunityId: ID!) {
    dealBuilder {
      getDealBuilders(vendorOpportunityId: $vendorOpportunityId) {
        success
        error
        entity {
          proposalId
          proposal {
            createdDateTime
            businessName
            firstName
            lastName
            saleType
            amountRequested
            status
            salesPersonName
            vendorOpportunityId
            proposalId
          }
          proposalContacts {
            proposalContactsId
            proposalId
            ownerPgId
            accountContactId
          }
          proposalEquipments {
            proposalEquipmentsId
            proposalId
            equipmentId
          }
        }
      }
    }
  }
`;
